import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Input, Table } from 'antd';

const { Search } = Input;

@inject('retailOfferStore')
@observer
class SearchMenuItemModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchedColumn: ''
        };
    }

    componentDidMount() {
    }

    getColumns = () => {
        return [
            {
                title: 'Retail',
                dataIndex: 'taskName',
                key: 'taskName',
                width: '40%'
            },
            {
                title: 'Category',
                dataIndex: 'parentName',
                key: 'parentName',
                width: '40%'
            },
            {
                title: 'Action',
                dataIndex: 'taskId',
                key: 'action',
                width: '10%',
                render: taskId => (
                    <span>
                        <Button onClick={() => this.selectSearchMenuItemClicked(taskId)} type='primary'>
                            Select
                        </Button>
                    </span>
                ),
            },
        ]
    }

    searchChanged = e => {
        this.props.retailOfferStore.setItemSearchValue(e.target.value);
        this.props.retailOfferStore.searchItem();
    }

    selectSearchMenuItemClicked = taskId => {
        this.props.retailOfferStore.searchItemSelected(taskId);
        this.props.retailOfferStore.setShowSearchMenuItemModal(false);
    }

    render() {
        const {
            lastChildItemFilter,
            itemSearchValue
        } = this.props.retailOfferStore;

        return (
            <React.Fragment>
                <Search style={{ marginBottom: 10 }} placeholder='Search Retail' value={itemSearchValue} onChange={this.searchChanged} />
                <Table columns={this.getColumns()} dataSource={lastChildItemFilter} />
            </React.Fragment>
        )
    }
}

export default SearchMenuItemModal